import { ApolloClient, InMemoryCache } from '@apollo/client';

let baseURL = window.location.host
if (baseURL.match(/localhost/)) baseURL = "localhost:4000"
baseURL = window.location.protocol + "//" + baseURL

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  connectToDevTools: false,
  uri: baseURL + "/graphql",
});